<template>
  <div class="overflow-hidden flex flex-col items-center justify-center">
    <div class="bg-gray-700 text-white w-4/5 max-w-sm flex flex-col items-center justify-center p-4 rounded-2xl opacity-75">
      <div class="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-ternary-400 mb-2"></div>
      <h2 class="text-center text-xl font-semibold animate-pulse">Loading...</h2>
      <p class="text-center animate-pulse">This may take a few seconds, please wait.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleLoader"
}
</script>